import type { StanFilterConfig } from '@/components/core-components/StanFilters/types';
import type { Tag } from '../../types/audience.types';

/**
 * Get filter configurations for recipients table
 */
export const getRecipientFilterConfigs = (availableTags: Tag[]): StanFilterConfig[] => {
    // Filter out "Everyone" tag and any pseudo tags (product tags)
    const tags = availableTags.filter(tag => tag.name !== 'Everyone' && tag.type !== 'pseudo');

    const baseFilters: StanFilterConfig[] = [
        {
            id: 'receipient-name',
            label: 'Name',
            type: 'text',
        },
        {
            id: 'receipient-eid',
            label: 'Email',
            type: 'text',
        },
        {
            id: 'receipient-status',
            label: 'Status',
            type: 'select',
            customDropdownReduce: 'type',
            customDropdownOptions: [
                { label: 'Subscribed', type: 'subscribed' },
                { label: 'Unsubscribed', type: 'unsubscribed' },
                { label: 'Requires Opt-In', type: 'require_opt_in' },
                { label: 'Opt-In Sent', type: 'opt_in_sent' },
            ],
        },
    ];

    // Only add tag filter if there are tags available
    if (tags.length > 0) {
        baseFilters.push({
            id: 'receipient-tags',
            label: 'Tag',
            type: 'select',
            customDropdownReduce: 'name',
            customDropdownOptions: tags.map(tag => ({
                label: tag.name,
                name: tag.name,
            })),
        });
    }

    return baseFilters;
};
